import { z } from "zod";

export const newPasswordSchema = z.object({
  password: z
    .string()
    .min(12, "Password must be at least 12 characters long")
    .regex(/.*[0-9].*/, "Password must contain at least 1 number")
    .regex(
      /.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ].*/,
      "Password must contain at least 1 special character",
    )
    .regex(/.*[A-Z].*/, "Password must contain at least 1 uppercase letter")
    .regex(/.*[a-z].*/, "Password must contain at least 1 lowercase letter"),
});

export type NewPasswordFormData = z.infer<typeof newPasswordSchema>;
